import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { BsSearch } from 'react-icons/bs';
import { useSelector, useDispatch } from 'react-redux';
import { fetchUsers, fetchSearch } from '../redux/fetchUser';
import NavbarBottom from './NavbarBottom';
import { ThreeCircles } from 'react-loader-spinner';

let loadPage = true;

function HalamanPencarian() {
    const params = useParams();
    const dispatch = useDispatch();
    const items = useSelector((state) => state.items);
    const doc = useSelector((state) => state.docs);
    const [catList, setCat] = useState([]);
    const [dataToDisplay, setDataToDisplay] = useState([]);
    const [dataDisplayView, setDataDisplayView] = useState(0);

    // Helper untuk mengganti nilai undefined/null dengan "-"
    const renderValue = (value) => (value !== undefined && value !== null && value !== '' ? value : '-');

    const handleSearch = async () => {
        const dokumen = document.getElementById('dokumen').value;
        const kategori = params.id;
        const tahun = document.getElementById('tahun').value;
        const status_dokumen = document.getElementById('status_dokumen').value;
        const nomordoc = document.getElementById('nomordoc').value;

        fetch(
            `${process.env.REACT_APP_API_ENDPOINT}/documents?dokumen=${dokumen}&kategori=${kategori}&tahun=${tahun}&status_dokumen=${status_dokumen}`
        )
            .then((response) => response.json())
            .then((res) => {
                dispatch(fetchSearch(res.data));
                setDataToDisplay(res.data);
            });

        if (!dokumen && !status_dokumen) {
            setDataDisplayView(0);
        } else {
            setDataDisplayView(1);
        }

        const data_filter = items;
        data_filter.dokumen_filter = dokumen;
        data_filter.kategori_filter = kategori;
        data_filter.tahun_filter = tahun;
        data_filter.status_dokumen_filter = status_dokumen;
        data_filter.nomor_doc_filter = nomordoc;

        dispatch(fetchUsers(data_filter));
    };

    const handleSearchPageNext = async (e) => {
        const dokumen = document.getElementById('dokumen').value;
        const kategori = params.id;
        const tahun = document.getElementById('tahun').value;
        const status_dokumen = document.getElementById('status_dokumen').value;

        fetch(
            `${process.env.REACT_APP_API_ENDPOINT}/documents?dokumen=${dokumen}&kategori=${kategori}&tahun=${tahun}&status_dokumen=${status_dokumen}&page=${e}`
        )
            .then((response) => response.json())
            .then((res) => {
                dispatch(fetchSearch(res.data));
                setDataToDisplay(res.data);
            });
    };

    const getCategories = () => {
        fetch(`${process.env.REACT_APP_API_ENDPOINT}/categories`)
            .then((res) => res.json())
            .then((datas) => {
                setCat(datas.data);
            });
    };

    const inisiateFilter = () => {
        dispatch(
            fetchUsers({
                dokumen_filter: '',
                kategori_filter: params.id,
                tahun_filter: '',
                status_dokumen_filter: '',
                nomor_doc_filter: '',
            })
        );
    };

    useEffect(() => {
        handleSearch();
    }, []);

    return (
        <>
            <NavbarBottom />
            <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
                <div className="max-w-6xl mx-auto space-y-8">
                    {/* Card Pencarian */}
                    <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 border border-gray-100">
                        <div className="space-y-4">
                            {/* Nama Dokumen */}
                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-1">
                                    Nama Dokumen
                                </label>
                                <input
                                    type="text"
                                    id="dokumen"
                                    defaultValue={items?.data?.dokumen_filter || ''}
                                    placeholder="Masukkan nama dokumen..."
                                    className="w-full px-4 py-2.5 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition"
                                />
                            </div>

                            {/* Jenis Dokumen */}
                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-1">
                                    Jenis Dokumen
                                </label>
                                <select
                                    id="kategori"
                                    defaultValue={items.data?.kategori_filter || params.id}
                                    className="w-full px-4 py-2.5 border border-gray-200 rounded-xl bg-white focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition"
                                >
                                    <option value={params.id}>{params.id}</option>
                                </select>
                            </div>

                            {/* Grid 3 kolom: Nomor, Tahun, Status */}
                            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-1">
                                        Nomor
                                    </label>
                                    <input
                                        type="text"
                                        id="nomordoc"
                                        defaultValue={items.data?.nomor_doc_filter || ''}
                                        placeholder="Nomor dokumen"
                                        className="w-full px-4 py-2.5 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-1">
                                        Tahun
                                    </label>
                                    <input
                                        type="text"
                                        id="tahun"
                                        defaultValue={items.data?.tahun_filter || ''}
                                        placeholder="Tahun"
                                        className="w-full px-4 py-2.5 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-1">
                                        Status
                                    </label>
                                    <select
                                        id="status_dokumen"
                                        defaultValue={items.data?.status_dokumen_filter || ''}
                                        className="w-full px-4 py-2.5 border border-gray-200 rounded-xl bg-white focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition"
                                    >
                                        <option value="">- Pilih Status -</option>
                                        <option value="1">Berlaku</option>
                                        <option value="0">Tidak Berlaku</option>
                                    </select>
                                </div>
                            </div>

                            {/* Tombol Cari */}
                            <div className="flex justify-center pt-2">
                                <button
                                    onClick={() => handleSearch()}
                                    className="flex items-center gap-2 px-8 py-3 bg-red-600 text-white font-bold rounded-xl hover:bg-red-700 transition shadow-md hover:shadow-lg"
                                >
                                    <BsSearch size={18} /> CARI
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Hasil Pencarian */}
                    <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 border border-gray-100">
                        {dataDisplayView === 0 ? (
                            // Tampilan Tabel
                            <>
                                {doc?.data?.data ? (
                                    <div className="overflow-x-auto">
                                        <div className="text-sm text-gray-600 mb-3">
                                            Halaman : {renderValue(doc.data.current_page)}
                                        </div>
                                        <table className="w-full text-sm text-left">
                                            <thead className="bg-gray-100 text-gray-700 text-xs uppercase tracking-wider">
                                                <tr>
                                                    <th className="px-4 py-3 rounded-l-lg">NO</th>
                                                    <th className="px-4 py-3">JUDUL</th>
                                                    <th className="px-4 py-3">JENIS</th>
                                                    <th className="px-4 py-3">NOMOR</th>
                                                    <th className="px-4 py-3">TAHUN</th>
                                                    <th className="px-4 py-3 rounded-r-lg">DETAIL</th>
                                                </tr>
                                            </thead>
                                            <tbody className="divide-y divide-gray-100">
                                                {doc.data.data.map((field, index) => {
                                                    const currentPage = doc.data.current_page || 1;
                                                    const perPage = doc.data.per_page || 10;
                                                    const rowNum =
                                                        currentPage === 1
                                                            ? index + 1
                                                            : (currentPage - 1) * perPage + index + 1;
                                                    return (
                                                        <tr
                                                            key={field.id}
                                                            className="hover:bg-gray-50 transition"
                                                        >
                                                            <td className="px-4 py-3 text-gray-500">{rowNum}</td>
                                                            <td className="px-4 py-3 font-medium text-gray-800">
                                                                {renderValue(field.content)}
                                                            </td>
                                                            <td className="px-4 py-3 text-gray-600">
                                                                {renderValue(field.nama)}
                                                            </td>
                                                            <td className="px-4 py-3 text-gray-600">
                                                                {renderValue(field.no_peraturan)}
                                                            </td>
                                                            <td className="px-4 py-3 text-gray-600">
                                                                {renderValue(field.tahun_diundang)}
                                                            </td>
                                                            <td className="px-4 py-3">
                                                                <Link to={`/detail-produk-hukum/${field.idph}`}>
                                                                    <button className="px-4 py-1.5 text-sm font-medium text-red-600 border border-red-600 rounded-lg hover:bg-red-600 hover:text-white transition">
                                                                        Lihat
                                                                    </button>
                                                                </Link>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>

                                        {/* Pagination */}
                                        <div className="flex justify-center mt-6">
                                            <nav aria-label="Page navigation">
                                                <ul className="flex items-center -space-x-px text-sm">
                                                    <li>
                                                        <a
                                                            href="#"
                                                            className="px-3 py-2 rounded-l-lg border border-gray-200 bg-white hover:bg-gray-50 text-gray-500"
                                                        >
                                                            Previous
                                                        </a>
                                                    </li>
                                                    {doc.data?.links?.map((fieldlink, indexlink) => (
                                                        <li key={indexlink}>
                                                            <a
                                                                href="#"
                                                                onClick={() =>
                                                                    handleSearchPageNext(fieldlink.label)
                                                                }
                                                                className={`px-3 py-2 border border-gray-200 bg-white hover:bg-gray-50 ${dataToDisplay.current_page === fieldlink.label
                                                                        ? 'bg-red-600 text-white hover:bg-red-700'
                                                                        : 'text-gray-500'
                                                                    }`}
                                                            >
                                                                {renderValue(fieldlink.label)}
                                                            </a>
                                                        </li>
                                                    ))}
                                                    <li>
                                                        <a
                                                            href="#"
                                                            className="px-3 py-2 rounded-r-lg border border-gray-200 bg-white hover:bg-gray-50 text-gray-500"
                                                        >
                                                            Next
                                                        </a>
                                                    </li>
                                                </ul>
                                            </nav>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="flex justify-center py-10">
                                        <ThreeCircles
                                            visible={true}
                                            height="50"
                                            width="50"
                                            color="#dc2626"
                                            ariaLabel="loading"
                                        />
                                    </div>
                                )}
                            </>
                        ) : (
                            // Tampilan Kartu
                            <>
                                <div className="space-y-6">
                                    <div className="text-sm text-gray-600">
                                        Halaman : {renderValue(doc.data?.current_page)}
                                    </div>
                                    {doc.data?.data?.map((field) => (
                                        <div
                                            key={field.id}
                                            className="bg-gray-50 rounded-xl p-6 border border-gray-100 shadow-sm hover:shadow-md transition"
                                        >
                                            <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-2">
                                                <div className="flex-1">
                                                    <p className="text-xs text-gray-400">
                                                        Nomor : {renderValue(field.no_peraturan)}
                                                    </p>
                                                    <Link to={`/detail-produk-hukum/${field.idph}`}>
                                                        <h2 className="text-lg font-bold text-gray-900 hover:text-red-600 transition">
                                                            {renderValue(field.content)}
                                                        </h2>
                                                    </Link>
                                                    <div className="flex flex-wrap items-center gap-3 mt-2">
                                                        <span className="text-xs text-gray-400">
                                                            Tahun {renderValue(field.tahun_diundang)}
                                                        </span>
                                                        {field.file_abstrak && (
                                                            <a
                                                                href={`${process.env.REACT_APP_BASEURL}/produk_hukum/abstrak/${field.file_abstrak}`}
                                                                className="text-xs bg-white px-3 py-1 rounded-full border border-gray-200 text-gray-700 hover:bg-gray-100 transition"
                                                            >
                                                                Abstrak
                                                            </a>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="mt-4 pt-3 border-t border-gray-200">
                                                <p className="text-sm text-gray-500">Download file:</p>
                                                <a
                                                    href={`${process.env.REACT_APP_BASEURL}/${field.file_url}`}
                                                    className="inline-flex items-center text-red-500 font-medium text-sm mt-1 hover:underline"
                                                >
                                                    <i className="fas fa-file-pdf mr-2"></i> {renderValue(field.sumber)}
                                                </a>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                {/* Pagination untuk card view */}
                                <div className="flex justify-center mt-8">
                                    <nav aria-label="Page navigation">
                                        <ul className="flex items-center -space-x-px text-sm">
                                            <li>
                                                <a
                                                    href="#"
                                                    className="px-3 py-2 rounded-l-lg border border-gray-200 bg-white hover:bg-gray-50 text-gray-500"
                                                >
                                                    Previous
                                                </a>
                                            </li>
                                            {doc.data?.links?.map((fieldlink, indexlink) => (
                                                <li key={indexlink}>
                                                    <a
                                                        href="#"
                                                        onClick={() => handleSearchPageNext(fieldlink.label)}
                                                        className={`px-3 py-2 border border-gray-200 bg-white hover:bg-gray-50 ${dataToDisplay.current_page === fieldlink.label
                                                                ? 'bg-red-600 text-white hover:bg-red-700'
                                                                : 'text-gray-500'
                                                            }`}
                                                    >
                                                        {renderValue(fieldlink.label)}
                                                    </a>
                                                </li>
                                            ))}
                                            <li>
                                                <a
                                                    href="#"
                                                    className="px-3 py-2 rounded-r-lg border border-gray-200 bg-white hover:bg-gray-50 text-gray-500"
                                                >
                                                    Next
                                                </a>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default HalamanPencarian;